var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.name)?_c('div',{staticClass:"help_button",on:{"click":function($event){return _vm.clicked(_vm.name)}}},[_vm._v(" ? ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }